// extracted by mini-css-extract-plugin
module.exports = {"namePassword":"_2Pxw_f3eKFBCdGCxj1ehbW"};